import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("状态")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("分类名称:")
const _hoisted_10 = { style: {"margin-top":"10px"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("是否显示: ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("显示")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("不显示")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "分类管理" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _ctx.add,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          placeholder: "关键字",
          value: _ctx.searches.keywords,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.keywords) = $event)),
          style: {"width":"200px"}
        }, null, 8, ["value"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: _ctx.onSearch,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: _ctx.onReset
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: _ctx.columns,
          bordered: "",
          pagination: _ctx.pagination,
          style: {"margin-top":"10px"},
          onChange: _ctx.handleTableChange
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'name')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(record.name), 1))
              : _createCommentVNode("", true),
            (column.key === 'is_show')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.is_show == '停用')
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "#f50"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(record.is_show), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (record.is_show == '启用')
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "#108ee9"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(record.is_show), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin-left":"10px"},
                    onClick: ($event: any) => (_ctx.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否删除该内容?",
                    onConfirm: ($event: any) => (_ctx.onDelete(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _ctx.handleOk,
      width: "20%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_9,
          _createVNode(_component_a_input, {
            value: _ctx.name,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
            placeholder: "分类名称",
            style: {"margin-top":"10px"}
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_a_select, {
            ref: "select",
            value: _ctx.is_show,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.is_show) = $event)),
            style: {"width":"100%"},
            placeholder: "请选择是否展示"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select_option, { value: 1 }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(_component_a_select_option, { value: 0 }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk"])
  ]))
}